<template>
    <share-button 
        :openShareCb="openShare"
        :color="color"
        :classes="classes"
    />
</template>

<script>
    import ShareButton from '../common/share/share-button.vue';

    export default {
        props: {
            outfit: Object,
            classes: String|Array|Object,
            color: String,
        },
        components: {
            ShareButton,
        },
        methods: {
            openShare() {
                if(this.outfit?.outfit_id) {
                    this.$store.commit('share/setSharedId', this.outfit.outfit_id);
                    this.$store.commit('share/setShareType', 'outfit');
                    this.$store.commit('share/openShareModal');
                }
            }
        },
    }
</script>
